import i18n from "../i18n";

export const handleColorStatusConsultRequestUtil = (
  status_type: string,
  handle_by: string
) => {
  if (status_type === "pending") {
    return i18n.t("รอตรวจสอบ");
  } else if (status_type === "response") {
    if (handle_by === "advisor") {
      return i18n.t("ตอบกลับแล้ว");
    } else {
      return i18n.t("มีการตอบกลับ");
    }
  } else if (status_type === "new_request") {
    if (handle_by === "advisor") {
      return i18n.t("ปรึกษาเพิ่มเติม");
    } else {
      return i18n.t("รอตรวจสอบ");
    }
  } else if (status_type === "success") {
    return i18n.t("สิ้นสุดการให้คำปรึกษา");
  } else {
    return "";
  }
};

export const handleTextStatusConsultRequestUtil = (status_type: string) => {
  if (status_type === "pending") {
    return "warning";
  } else if (status_type === "response") {
    return "info";
  } else if (status_type === "new_request") {
    return "warning";
  } else if (status_type === "success") {
    return "success";
  } else {
    return "default";
  }
};

export const allStatusConsultRequestUtil = [
  "pending",
  "response",
  "new_request",
  "success",
];

// i18n-ignore: ค่าสถานะใช้เป็น id_status ส่งไป backend ผู้เรียกแปลตอนแสดงผลด้วย t()
export const allStatusAdvisorRequestUtil = [
  "รอพิจารณา", // i18n-ignore
  "ตอบรับเป็นที่ปรึกษา", // i18n-ignore
  "ปฏิเสธคำขอ", // i18n-ignore
  "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง", // i18n-ignore
  "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง", // i18n-ignore
  "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา", // i18n-ignore
];
